const boxParams = {
  title: '热销商品',
  subTitle: 'Hot Sales',
  showMore: true,
  showHeader: true,
  icon: 'http://s3.zhifu88.cn/zhifu/461320220629141108.png',
  showIcon: true
}
const boxStyle = {
  boxType: 'block',
  showTopBorder: false,
  showRightBorder: false,
  showBottomBorder: true,
  showLeftBorder: false,
  showTopPadding: true,
  showRightPadding: true,
  showBottomPadding: true,
  showLeftPadding: true,
  showHeader: true,
  showBorderRadius: false,
  backgroundColor: 'rgba(255,255,255,1)',
  layoutType: '1row2column',
  itemBackgroundColor: 'rgba(255,255,255,1)',
  itemShowBorderRadius: false,
  itemImgShowBorderRadius: false,
  itemBoxType: 'block'
}
const treOneStyle = {
  showTopBorder: false,
  showRightBorder: false,
  showBottomBorder: true,
  showLeftBorder: false,
  showBorderRadius: false,
  showLeftPadding: true,
  showRightPadding: true,
  showTopPadding: true,
  showBottomPadding: true,
  showImgBorderRadius: false,
  boxType: 'block',
  backgroundColor: 'rgba(255,255,255,1)',
}
const treTwoStyle = {
  showTopBorder: false,
  showRightBorder: false,
  showBottomBorder: true,
  showLeftBorder: false,
  showBorderRadius: false,
  showLeftPadding: true,
  showRightPadding: true,
  showTopPadding: true,
  showBottomPadding: true,
  showSpace: true,
  showImgBorderRadius: false,
  boxType: 'block',
  backgroundColor: 'rgba(255,255,255,1)',
}
const treMoreStyle = {
  showTopBorder: false,
  showRightBorder: false,
  showBottomBorder: true,
  showLeftBorder: false,
  showBorderRadius: false,
  showLeftPadding: true,
  showRightPadding: true,
  showTopPadding: true,
  showBottomPadding: true,
  showSpace: true,
  showImgBorderRadius: false,
  boxType: 'block',
  backgroundColor: 'rgba(255,255,255,1)',
}
export default [
  // {
  //   icon:
  //     'M512 0a512 512 0 0 0 0 1024c180.224 0-110.592-204.8 204.8-204.8a302.08 302.08 0 0 0 307.2-307.2A512 512 0 0 0 512 0zM179.2 486.4A76.8 76.8 0 1 1 256 409.6a76.8 76.8 0 0 1-76.8 76.8zM358.4 307.2a76.8 76.8 0 1 1 76.8-76.8A76.8 76.8 0 0 1 358.4 307.2z m307.2 0a76.8 76.8 0 1 1 76.8-76.8A76.8 76.8 0 0 1 665.6 307.2z m179.2 179.2A76.8 76.8 0 1 1 921.6 409.6a76.8 76.8 0 0 1-76.8 76.8z',
  //   name: '主题颜色',
  //   chilren: [
  //     {
  //       name: '推荐主题色',
  //       code: 'ColorList',
  //       values: [
  //         '#FA436A',
  //         '#67C23A',
  //         '#E6A23C',
  //         '#F56C6C',
  //         '#248AFD',
  //         '#6E41F2',
  //         '#909399',
  //         '#303133'
  //       ]
  //     },
  //     {
  //       name: '自定义主题色',
  //       code: 'ColorPicker'
  //     }
  //   ]
  // },
  {
    icon:'M431.407407 170.666667v260.74074H170.666667V170.666667h260.74074m20.195556-42.666667H150.471111c-12.325926 0-22.471111 10.145185-22.471111 22.471111v301.226667c0 12.325926 10.145185 22.471111 22.471111 22.471111h301.226667c12.325926 0 22.471111-10.145185 22.471111-22.471111V150.471111c-0.094815-12.325926-10.24-22.471111-22.565926-22.471111zM431.407407 592.592593v260.74074H170.666667V592.592593h260.74074m20.195556-42.666667H150.471111c-12.325926 0-22.471111 10.145185-22.471111 22.471111v301.226667c0 12.325926 10.145185 22.471111 22.471111 22.471111h301.226667c12.325926 0 22.471111-10.145185 22.471111-22.471111V572.397037c-0.094815-12.325926-10.24-22.471111-22.565926-22.471111zM853.333333 592.592593v260.74074H592.592593V592.592593h260.74074m20.195556-42.666667H572.397037c-12.325926 0-22.471111 10.145185-22.471111 22.471111v301.226667c0 12.325926 10.145185 22.471111 22.471111 22.471111h301.226667c12.325926 0 22.471111-10.145185 22.471111-22.471111V572.397037c-0.094815-12.325926-10.24-22.471111-22.565926-22.471111zM853.333333 170.666667v260.74074H592.592593V170.666667h260.74074m20.48-42.666667H572.112593c-12.231111 0-22.186667 9.955556-22.186667 22.186667v301.70074c0 12.231111 9.955556 22.186667 22.186667 22.186667h301.70074c12.231111 0 22.186667-9.955556 22.186667-22.186667V150.186667c0-12.231111-9.955556-22.186667-22.186667-22.186667z',
    name: '基础组件',
    chilren: [
      {
        name: '基础组件',
        code: 'ModuleList',
        values: [
          {
            code: 'swiper-search',
            sort: 0,
            name: '带搜索的轮播图',
            icon: 'http://s3.zhifu88.cn/zhifu/986320220712171723.png',
            params: {
              placeholder: '请输入关键字搜索'
            },
            data: [{
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            }
            ],
            style: {
              showTopBorder: false,
              showBottomBorder: true,
              dotType: 1
            }
          },
          {
            code: 'search',
            sort: 1,
            name: '搜索框',
            icon: 'http://s3.zhifu88.cn/zhifu/836620220629134950.png',
            params: {
              placeholder: '请输入关键字搜索',
              inputBackgroundColor: 'rgba(248, 248, 248,1)',
              placeholderColor: 'rgba(149, 149, 149,1)',
              showImage: false,
            },
            data: {
              src: '',
              navTo: ''
            },
            style: {
              showTopBorder: false,
              showRightBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showBorderRadius: false,
              showLeftPadding: false,
              showRightPadding: false,
              showTopPadding: false,
              showBottomPadding: false,
              boxType: 'block',
              backgroundColor: 'rgba(255,255,255,1)',
            }
          },
          {
            code: 'nav',
            sort: 2,
            name: '导航',
            icon: 'http://s3.zhifu88.cn/zhifu/282520220629134919.png',
            params: {},
            data: [{
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              name: '导航1',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              name: '导航2',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              name: '导航3',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              name: '导航4',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              name: '导航5',
              navTo: ''
            }
            ],
            style: {
              showTopBorder: false,
              showRightBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showBorderRadius: false,
              boxType: 'block',
              circle: true,
              showLeftPadding: true,
              showRightPadding: true,
              showTopPadding: true,
              showBottomPadding: true,
              showType: 'flex-row',
              imgType: 'small',
              backgroundColor: 'rgba(255,255,255,1)',
              titleColor: 'rgba(0,0,0,1)',
              num: 5
            }
          },
          {
            code: 'swiper',
            sort: 3,
            name: '轮播图',
            icon: 'http://s3.zhifu88.cn/zhifu/958020220629134950.png',
            params: {},
            data: [{
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            }
            ],
            style: {
              showTopBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showRightBorder: false,
              showBorderRadius: false,
              boxType: 'block',
              dotType: 1,
            }
          },

          {
            code: 'img-one',
            sort: 5,
            name: '单图',
            icon: 'http://s3.zhifu88.cn/zhifu/520120220712171723.png',
            params: {},
            data: {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            style: {
              showTopBorder: false,
              showRightBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showBorderRadius: false,
              showLeftPadding: true,
              showRightPadding: true,
              showTopPadding: true,
              showBottomPadding: true,
              showImgBorderRadius: false,
              boxType: 'block',
              backgroundColor: 'rgba(255,255,255,1)',
            }
          },
          {
            code: 'img-two',
            sort: 6,
            name: '双图',
            icon: 'http://s3.zhifu88.cn/zhifu/493420220629134950.png',
            params: {},
            data: [{
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            }
            ],
            style: {
              showTopBorder: false,
              showRightBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showBorderRadius: false,
              showLeftPadding: true,
              showRightPadding: true,
              showTopPadding: true,
              showBottomPadding: true,
              showSpace: true,
              showImgBorderRadius: false,
              boxType: 'block',
              backgroundColor: 'rgba(255,255,255,1)',
            }
          },
          {
            code: 'img-more',
            sort: 7,
            name: '多图',
            icon: 'http://s3.zhifu88.cn/zhifu/493420220629134950.png',
            params: {},
            data: [{
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            }
            ],
            style: {
              showTopBorder: false,
              showRightBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showBorderRadius: false,
              showLeftPadding: true,
              showRightPadding: true,
              showTopPadding: true,
              showBottomPadding: true,
              showSpace: true,
              showImgBorderRadius: false,
              boxType: 'block',
              backgroundColor: 'rgba(255,255,255,1)',
            }
          },

          {
            code: 'friend',
            sort: 11,
            params: {
              title: '友情链接'
            },
            name: '友情链接',
            icon: 'http://s3.zhifu88.cn/zhifu/384520220629134951.png',
            data: [{
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            {
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            }
            ],
            style: {
              showBottomBorder: true,
              showBorderRadius: false,
              boxType: 'block',
              imageBorderRadius: true
            }
          },
          {
            code: 'header',
            sort: 2,
            name: '标题模块',
            icon: 'http://s3.zhifu88.cn/zhifu/400220220712171723.png',
            params: {
              title: '商品分类',
              subTitle: 'Hot Sales',
              showMore: true,
              icon: 'https://res.zhifu88.cn/alachuang/854020200508211355/hot.png',
              showIcon: true
            },
            data: {
              name: '商品分类',
              navTo: '/pages/category/category'
            },
            style: {
              boxType: 'block',
              showTopBorder: false,
              showRightBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showTopPadding: true,
              showRightPadding: true,
              showBottomPadding: true,
              showLeftPadding: true,
              backgroundColor: 'rgba(255,255,255,1)',
              showBorderRadius: false,
            }
          },
          {
            code: 'open',
            sort: 2,
            name: '公众号',
            icon: 'http://s3.zhifu88.cn/zhifu/270520220629134950.png',
            params: {
              title: '公众号名称',
              subTitle: '文字简介',
              icon: 'https://res.zhifu88.cn/alachuang/854020200508211355/hot.png'
            },
            data: false,
            style: {
              boxType: 'block',
              showBottomBorder: true,
              showBorderRadius: false,
            }
          },
          {
            code: 'video',
            sort: 2,
            name: '视频播放器',
            icon: 'http://s3.zhifu88.cn/zhifu/736320220629134950.png',
            params: {

            },
            data: {
              src: '',
              cover: ''
            },
            style: {
              showTopBorder: false,
              showRightBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showTopPadding: false,
              showRightPadding: false,
              showBottomPadding: false,
              showLeftPadding: false,
              showBorderRadius: false,
              boxType: 'block',
              circle: true
            }
          },
          {
            code: 'swiper-card',
            sort: 2,
            name: '滑动卡片',
            icon: 'http://s3.zhifu88.cn/zhifu/813420220629134950.png',
            params: {

            },
            data: [
              {
                type: 'image',
                title: '商品',
                list: [{
                  src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png'
                }],
              },
              {
                type: 'video',
                title: '视频课程',
                list: []
              }
            ],
            style: {
              showTopBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showRightBorder: false,
              showBorderRadius: false,
              titleColor: 'rgba(0,0,0,1)',
              backgroundColor: 'rgba(255,255,255,0)',
              cardBackgroundColor: 'rgba(255,255,255,0)',
              boxType: 'block',
            }
          },
          {
            code: 'swiper-card2',
            sort: 2,
            name: '滑动卡片2',
            icon: 'http://s3.zhifu88.cn/zhifu/697420220629134950.png',
            params: {

            },
            data: [
              {
                type: 'image',
                img: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                list: [{
                  src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png'
                }],
              },
              {
                type: 'video',
                img: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                list: []
              }
            ],
            style: {
              showTopBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showRightBorder: false,
              showBorderRadius: false,
              titleColor: 'rgba(0,0,0,1)',
              backgroundColor: 'rgba(255,255,255,0)',
              cardBackgroundColor: 'rgba(255,255,255,0)',
              boxType: 'block',
            }
          },
          {
            code: 'recommend',
            sort: 2,
            name: '推荐',
            icon: 'http://s3.zhifu88.cn/zhifu/732320220629134950.png',
            params: {

            },
            data: [
              {
                type: 'image',
                title: '进口海产',
                subTitle: '高蛋白波士顿龙虾',
                list: [{
                  src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                  navTo: ''
                }, {
                  src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                  navTo: ''
                }]
              },
              {
                type: 'image',
                title: '产地量贩',
                subTitle: '海鲜拼盘限量49.9元',
                list: [{
                  src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                  navTo: ''
                }, {
                  src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                  navTo: ''
                }]
              }
            ],
            style: {
              showTopBorder: true,
              showRightBorder: true,
              showBottomBorder: true,
              showLeftBorder: true,
              showBorderRadius: true,
              showLeftPadding: false,
              showRightPadding: false,
              showTopPadding: false,
              showBottomPadding: false,
              showSpace: true,
              showImgBorderRadius: false,
              boxType: 'block',
              backgroundColor: 'rgba(255,255,255,0)',
              cardBackgroundColor: 'rgba(255,255,255,1)',
            }
          },
          {
            code: 'swiper-lrregular',
            sort: 2,
            name: '推荐1',
            icon: 'http://s3.zhifu88.cn/zhifu/332320220629134950.png',
            params: {

            },
            data: [
              {
                src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                title: '标题1',
                navTo: ''
              }, {
                src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                title: '标题2',
                navTo: ''
              },
            ],
            style: {
              showTopBorder: false,
              showRightBorder: false,
              showBottomBorder: true,
              showLeftBorder: false,
              showBorderRadius: false,
              showLeftPadding: false,
              showRightPadding: false,
              showTopPadding: false,
              showBottomPadding: false,
              showImgBorderRadius: true,
              boxType: 'block',
              backgroundColor: 'rgba(255,255,255,0)',
            }
          },
          {
            code: 'img-text',
            sort: 2,
            name: '半图半文',
            icon: 'http://s3.zhifu88.cn/zhifu/396920220712171723.png',
            params: {

            },
            data: {
              title: '标题',
              subTitle: '副标题',
              src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
              navTo: ''
            },
            style: {
              showTopBorder: true,
              showRightBorder: true,
              showBottomBorder: true,
              showLeftBorder: true,
              showBorderRadius: false,
              showLeftPadding: false,
              showRightPadding: false,
              showTopPadding: false,
              showBottomPadding: false,
              showImgBorderRadius: true,
              boxType: 'block',
              backgroundColor: 'rgba(255,255,255,0)',
              cardBackgroundColor: 'rgba(255,255,255,1)',
            }
          },
        ]
      }
    ]
  },
  {
    icon:
      'M512 0a512 512 0 0 0 0 1024c180.224 0-110.592-204.8 204.8-204.8a302.08 302.08 0 0 0 307.2-307.2A512 512 0 0 0 512 0zM179.2 486.4A76.8 76.8 0 1 1 256 409.6a76.8 76.8 0 0 1-76.8 76.8zM358.4 307.2a76.8 76.8 0 1 1 76.8-76.8A76.8 76.8 0 0 1 358.4 307.2z m307.2 0a76.8 76.8 0 1 1 76.8-76.8A76.8 76.8 0 0 1 665.6 307.2z m179.2 179.2A76.8 76.8 0 1 1 921.6 409.6a76.8 76.8 0 0 1-76.8 76.8z',
    name: '资源组件',
    chilren: [
      {
        name: '商品',
        code: 'ModuleList',
        values: [
          {
            code: 'box',
            sort: 4,
            name: '商品列表',
            icon: 'http://s3.zhifu88.cn/zhifu/365020220629134950.png',
            params: boxParams,
            data: {
              type: 'product',
              maxLength: 10,
              list: []
            },
            style: boxStyle
          },
          {
            code: 'tre-one',
            sort: 8,
            params: {},
            name: '单商品',
            icon: 'http://s3.zhifu88.cn/zhifu/892820220629134919.png',
            data: {
              type: 'product',
              data: {
                id: undefined,
                picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                name: '资源1',
                subName: '资源1',
                price: 0,
                scanNum: 0
              }
            },
            style: treOneStyle
          },
          {
            code: 'tre-two',
            sort: 9,
            params: {},
            name: '双商品',
            icon: 'http://s3.zhifu88.cn/zhifu/484520220629134919.png',
            data: {
              type: 'product',
              maxLength: 2,
              list: [{
                id: undefined,
                picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                name: '资源1',
                subName: '资源1',
                price: 0,
                scanNum: 0
              },
              {
                id: undefined,
                picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                name: '资源2',
                subName: '资源2',
                price: 0,
                scanNum: 0
              }
              ]
            },
            style: treTwoStyle
          },
          {
            code: 'tre-more',
            sort: 10,
            params: {},
            name: '多个商品',
            icon: 'http://s3.zhifu88.cn/zhifu/484520220629134919.png',
            data: {
              type: 'product',
              maxLength: 10,
              list: [{
                id: undefined,
                picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                name: '资源1',
                subName: '资源1',
                price: 0,
                scanNum: 0
              },
              {
                id: undefined,
                picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                name: '资源2',
                subName: '资源2',
                price: 0,
                scanNum: 0
              },
              {
                id: undefined,
                picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                name: '资源3',
                subName: '资源3',
                price: 0,
                scanNum: 0
              },
              {
                id: undefined,
                picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
                name: '资源3',
                subName: '资源4',
                price: 0,
                scanNum: 0
              }
              ]
            },
            style: treMoreStyle
          },
        ]
      },
      // {
      //   name: '视频课程',
      //   code: 'ModuleList',
      //   values: [
      //     {
      //       code: 'box',
      //       sort: 4,
      //       name: '视频列表',
      //       icon: 'http://s3.zhifu88.cn/zhifu/196320220629134950.png',
      //       params: boxParams,
      //       data: {
      //         type: 'video',
      //         maxLength: 10,
      //         list: []
      //       },

      //       style: boxStyle
      //     },
      //     {
      //       code: 'tre-one',
      //       sort: 8,
      //       params: {},
      //       name: '单视频',
      //       icon: 'http://s3.zhifu88.cn/zhifu/247220220712171723.png',
      //       data: {
      //         type: 'video',
      //         data: {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         }
      //       },
      //       style: treOneStyle
      //     },
      //     {
      //       code: 'tre-two',
      //       sort: 9,
      //       params: {},
      //       name: '双视频',
      //       icon: 'http://s3.zhifu88.cn/zhifu/163620220629134950.png',
      //       data: {
      //         type: 'video',
      //         maxLength: 2,
      //         list: [{
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源2',
      //           subName: '资源2',
      //           price: 0,
      //           scanNum: 0
      //         }
      //         ]
      //       },
      //       style: treTwoStyle
      //     },
      //     {
      //       code: 'tre-more',
      //       sort: 10,
      //       params: {},
      //       name: '多个视频',
      //       icon: 'http://s3.zhifu88.cn/zhifu/568620220629134919.png',
      //       data: {
      //         type: 'video',
      //         maxLength: 10,
      //         list: [{
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源2',
      //           subName: '资源2',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源3',
      //           subName: '资源3',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源3',
      //           subName: '资源4',
      //           price: 0,
      //           scanNum: 0
      //         }
      //         ]
      //       },
      //       style: treMoreStyle
      //     },
      //   ]
      // },
      // {
      //   name: '音频课程',
      //   code: 'ModuleList',
      //   values: [
      //     {
      //       code: 'box',
      //       sort: 4,
      //       name: '音频列表',
      //       icon: 'http://s3.zhifu88.cn/zhifu/804320220629134951.png',
      //       params: boxParams,
      //       data: {
      //         type: 'audio',
      //         maxLength: 10,
      //         list: []
      //       },

      //       style: boxStyle
      //     },
      //     {
      //       code: 'tre-one',
      //       sort: 8,
      //       params: {},
      //       name: '单音频',
      //       icon: 'http://s3.zhifu88.cn/zhifu/933420220629134919.png',
      //       data: {
      //         type: 'audio',
      //         data: {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         }
      //       },
      //       style: treOneStyle
      //     },
      //     {
      //       code: 'tre-two',
      //       sort: 9,
      //       params: {},
      //       name: '双音频',
      //       icon: 'http://s3.zhifu88.cn/zhifu/867120220712171724.png',
      //       data: {
      //         type: 'audio',
      //         maxLength: 2,
      //         list: [{
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源2',
      //           subName: '资源2',
      //           price: 0,
      //           scanNum: 0
      //         }
      //         ]
      //       },
      //       style: treTwoStyle
      //     },
      //     {
      //       code: 'tre-more',
      //       sort: 10,
      //       params: {},
      //       name: '多个音频',
      //       icon: 'http://s3.zhifu88.cn/zhifu/846520220629134950.png',
      //       data: {
      //         type: 'audio',
      //         maxLength: 10,
      //         list: [{
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源2',
      //           subName: '资源2',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源3',
      //           subName: '资源3',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源3',
      //           subName: '资源4',
      //           price: 0,
      //           scanNum: 0
      //         }
      //         ]
      //       },
      //       style: treMoreStyle
      //     },
      //   ]
      // },
      // {
      //   name: '图文课程',
      //   code: 'ModuleList',
      //   values: [
      //     {
      //       code: 'box',
      //       sort: 4,
      //       name: '图文列表',
      //       icon: 'M512.000918 512.002367c-125.269475 0-229.797147-90.437931-251.744912-209.455496 14.62756-10.295643 24.192651-27.289237 24.192651-46.535061 0-31.419242-25.468364-56.894948-56.887606-56.894948-31.419242 0-56.887606 25.475706-56.887606 56.894948 0 22.766423 13.386723 42.405055 32.709639 51.489231 24.629514 148.107485 153.63435 261.388932 308.625176 261.388932 154.983484 0 283.988319-113.281447 308.617833-261.388932 19.322917-9.084175 32.702297-28.722808 32.702297-51.489231 0-31.419242-25.461021-56.894948-56.880264-56.894948s-56.894948 25.475706-56.894948 56.894948c0 19.245824 9.572433 36.24676 24.199994 46.535061C741.79623 421.571778 637.277735 512.002367 512.000918 512.002367L512.000918 512.002367zM910.215997 0.01024l-28.408928 0c-0.007342 0-0.022027 0-0.036712 0L682.663736 0.01024c-0.007342 0-0.022027 0-0.036712 0l-3.549969 0c0.022027 0.078929 0.042218 0.1652 0.056902 0.24413-14.038346 1.734602-24.915861 13.687754-24.915861 28.199674 0 14.51192 10.877515 26.465071 24.915861 28.199674-0.022027 0.086271-0.036712 0.1652-0.056902 0.24413l231.137105 0c31.36234 0 56.894948 25.532609 56.894948 56.887606l0 796.439336c0 31.36234-25.532609 56.887606-56.894948 56.887606L113.784003 967.112394c-31.36234 0-56.887606-25.525266-56.887606-56.887606L56.896397 113.785452c0-31.354997 25.525266-56.887606 56.887606-56.887606L316.477305 56.897846c-0.022027-0.078929-0.034876-0.157858-0.056902-0.24413 14.038346-1.734602 24.915861-13.687754 24.915861-28.199674 0-14.51192-10.877515-26.465071-24.915861-28.199674 0.014685-0.086271 0.034876-0.1652 0.056902-0.24413l-3.548134 0c-0.014685 0-0.022027 0-0.036712 0L113.784003 0.01024c-0.027534 0-0.049561 0-0.071586 0C50.995079 0.052457 0.008791 51.060772 0.008791 113.785452l0 796.439336c0 62.746707 51.022999 113.775212 113.775212 113.775212l796.431993 0c62.754048 0 113.775212-51.030342 113.775212-113.775212L1023.991209 113.785452C1023.991209 51.033239 972.970045 0.01024 910.215997 0.01024L910.215997 0.01024zM910.215997 0.01024',
      //       params: boxParams,
      //       data: {
      //         type: 'image',
      //         maxLength: 10,
      //         list: []
      //       },

      //       style: boxStyle
      //     },
      //     {
      //       code: 'tre-one',
      //       sort: 8,
      //       params: {},
      //       name: '单图文',
      //       icon: 'M165.789 99.167h783c22.5 0 40.5 18 40.5 40.5v319.5c-40.5-31.5-117-81-175.5-81-85.5 0-162 198-256.5 198-72-4.5-171-85.5-283.5-72-45 9-108 81-148.5 135v-499.5c0-22.5 18-40.5 40.5-40.5zM354.788 423.167c-36 0-67.5-13.5-90-36s-36-58.5-36-90c0-31.5 13.5-67.5 36-90 22.5-22.5 54-36 90-36 31.5 0 63 13.5 90 36 22.5 22.5 36 58.5 36 90 0 31.5-13.5 67.5-36 90-27 22.5-58.5 36-90 36zM971.288 40.667h-828c-45 0-81 36-81 81v738c0 45 36 81 81 81h828c45 0 81-36 81-81v-738c0-45-36-81-81-81z',
      //       data: {
      //         type: 'image',
      //         data: {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         }
      //       },
      //       style: treOneStyle
      //     },
      //     {
      //       code: 'tre-two',
      //       sort: 9,
      //       params: {},
      //       name: '双图文',
      //       icon: 'M888.884513 171.979487l1.024 6.406564 15.596308 108.806564 3.203282 0.183795a196.923077 196.923077 0 0 1 185.842871 199.916308l-0.210051 6.459077-15.937641 320.905846a196.923077 196.923077 0 0 1-206.454154 186.919385l-498.162872-32.295385a196.923077 196.923077 0 0 1-184.162461-193.929846 196.949333 196.949333 0 0 1-134.852923-151.788308l-1.155282-6.931692-47.156513-313.501539a196.923077 196.923077 0 0 1 159.166359-222.995692l6.301538-1.050256L668.278154 11.237744a196.923077 196.923077 0 0 1 220.553846 160.768zM511.684923 613.139692l-3.465846 2.940718-226.67159 210.996513a118.101333 118.101333 0 0 0 97.332513 63.645539l495.195897 32.111589 7.351795 0.262564a118.180103 118.180103 0 0 0 103.581539-60.757333l-162.264616-151.289436a42.089026 42.089026 0 0 0-51.331282-4.726154l-3.36082 2.363077-26.098872 20.48a52.512821 52.512821 0 0 1-69.526974-4.201025l-2.993231-3.255795-85.333333-101.060923-1.654154-1.890462a52.512821 52.512821 0 0 0-70.761026-5.618872z m-106.574769-275.114666a118.153846 118.153846 0 0 0-123.090051 112.981333l-13.548308 316.468513 203.986051-189.833846a105.025641 105.025641 0 0 1 148.427487 5.330051l3.360821 3.807179 85.333333 101.034667 26.072616-20.453744a94.601846 94.601846 0 0 1 118.731487 1.601642l4.174769 3.675897 141.495795 131.938461 15.596308-314.683076a118.153846 118.153846 0 0 0-105.83959-123.405129l-5.513846-0.420102z m279.368205-249.357129l-5.513846 0.630154L183.611077 157.013333a118.153846 118.153846 0 0 0-99.958154 128.866462l0.708923 5.513846L131.492103 604.947692a117.996308 117.996308 0 0 0 61.387487 86.75118l10.450051-244.053334a196.923077 196.923077 0 0 1 205.141333-188.33723l416.794257 23.420718-13.338257-93.131488a118.153846 118.153846 0 0 0-127.448615-100.929641z m168.854974 310.875898a91.897436 91.897436 0 1 1 0 183.794872 91.897436 91.897436 0 0 1 0-183.794872z m0 52.51282a39.384615 39.384615 0 1 0 0 78.769231 39.384615 39.384615 0 0 0 0-78.769231z',
      //       data: {
      //         type: 'image',
      //         maxLength: 2,
      //         list: [{
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源2',
      //           subName: '资源2',
      //           price: 0,
      //           scanNum: 0
      //         }
      //         ]
      //       },
      //       style: treTwoStyle
      //     },
      //     {
      //       code: 'tre-more',
      //       sort: 10,
      //       params: {},
      //       name: '多个图文',
      //       icon: 'M888.884513 171.979487l1.024 6.406564 15.596308 108.806564 3.203282 0.183795a196.923077 196.923077 0 0 1 185.842871 199.916308l-0.210051 6.459077-15.937641 320.905846a196.923077 196.923077 0 0 1-206.454154 186.919385l-498.162872-32.295385a196.923077 196.923077 0 0 1-184.162461-193.929846 196.949333 196.949333 0 0 1-134.852923-151.788308l-1.155282-6.931692-47.156513-313.501539a196.923077 196.923077 0 0 1 159.166359-222.995692l6.301538-1.050256L668.278154 11.237744a196.923077 196.923077 0 0 1 220.553846 160.768zM511.684923 613.139692l-3.465846 2.940718-226.67159 210.996513a118.101333 118.101333 0 0 0 97.332513 63.645539l495.195897 32.111589 7.351795 0.262564a118.180103 118.180103 0 0 0 103.581539-60.757333l-162.264616-151.289436a42.089026 42.089026 0 0 0-51.331282-4.726154l-3.36082 2.363077-26.098872 20.48a52.512821 52.512821 0 0 1-69.526974-4.201025l-2.993231-3.255795-85.333333-101.060923-1.654154-1.890462a52.512821 52.512821 0 0 0-70.761026-5.618872z m-106.574769-275.114666a118.153846 118.153846 0 0 0-123.090051 112.981333l-13.548308 316.468513 203.986051-189.833846a105.025641 105.025641 0 0 1 148.427487 5.330051l3.360821 3.807179 85.333333 101.034667 26.072616-20.453744a94.601846 94.601846 0 0 1 118.731487 1.601642l4.174769 3.675897 141.495795 131.938461 15.596308-314.683076a118.153846 118.153846 0 0 0-105.83959-123.405129l-5.513846-0.420102z m279.368205-249.357129l-5.513846 0.630154L183.611077 157.013333a118.153846 118.153846 0 0 0-99.958154 128.866462l0.708923 5.513846L131.492103 604.947692a117.996308 117.996308 0 0 0 61.387487 86.75118l10.450051-244.053334a196.923077 196.923077 0 0 1 205.141333-188.33723l416.794257 23.420718-13.338257-93.131488a118.153846 118.153846 0 0 0-127.448615-100.929641z m168.854974 310.875898a91.897436 91.897436 0 1 1 0 183.794872 91.897436 91.897436 0 0 1 0-183.794872z m0 52.51282a39.384615 39.384615 0 1 0 0 78.769231 39.384615 39.384615 0 0 0 0-78.769231z',
      //       data: {
      //         type: 'image',
      //         maxLength: 10,
      //         list: [{
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源2',
      //           subName: '资源2',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源3',
      //           subName: '资源3',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源3',
      //           subName: '资源4',
      //           price: 0,
      //           scanNum: 0
      //         }
      //         ]
      //       },
      //       style: treMoreStyle
      //     },
      //   ]
      // },
      // {
      //   name: '直播课程',
      //   code: 'ModuleList',
      //   values: [
      //     {
      //       code: 'box',
      //       sort: 4,
      //       name: '直播列表',
      //       icon: 'M512.000918 512.002367c-125.269475 0-229.797147-90.437931-251.744912-209.455496 14.62756-10.295643 24.192651-27.289237 24.192651-46.535061 0-31.419242-25.468364-56.894948-56.887606-56.894948-31.419242 0-56.887606 25.475706-56.887606 56.894948 0 22.766423 13.386723 42.405055 32.709639 51.489231 24.629514 148.107485 153.63435 261.388932 308.625176 261.388932 154.983484 0 283.988319-113.281447 308.617833-261.388932 19.322917-9.084175 32.702297-28.722808 32.702297-51.489231 0-31.419242-25.461021-56.894948-56.880264-56.894948s-56.894948 25.475706-56.894948 56.894948c0 19.245824 9.572433 36.24676 24.199994 46.535061C741.79623 421.571778 637.277735 512.002367 512.000918 512.002367L512.000918 512.002367zM910.215997 0.01024l-28.408928 0c-0.007342 0-0.022027 0-0.036712 0L682.663736 0.01024c-0.007342 0-0.022027 0-0.036712 0l-3.549969 0c0.022027 0.078929 0.042218 0.1652 0.056902 0.24413-14.038346 1.734602-24.915861 13.687754-24.915861 28.199674 0 14.51192 10.877515 26.465071 24.915861 28.199674-0.022027 0.086271-0.036712 0.1652-0.056902 0.24413l231.137105 0c31.36234 0 56.894948 25.532609 56.894948 56.887606l0 796.439336c0 31.36234-25.532609 56.887606-56.894948 56.887606L113.784003 967.112394c-31.36234 0-56.887606-25.525266-56.887606-56.887606L56.896397 113.785452c0-31.354997 25.525266-56.887606 56.887606-56.887606L316.477305 56.897846c-0.022027-0.078929-0.034876-0.157858-0.056902-0.24413 14.038346-1.734602 24.915861-13.687754 24.915861-28.199674 0-14.51192-10.877515-26.465071-24.915861-28.199674 0.014685-0.086271 0.034876-0.1652 0.056902-0.24413l-3.548134 0c-0.014685 0-0.022027 0-0.036712 0L113.784003 0.01024c-0.027534 0-0.049561 0-0.071586 0C50.995079 0.052457 0.008791 51.060772 0.008791 113.785452l0 796.439336c0 62.746707 51.022999 113.775212 113.775212 113.775212l796.431993 0c62.754048 0 113.775212-51.030342 113.775212-113.775212L1023.991209 113.785452C1023.991209 51.033239 972.970045 0.01024 910.215997 0.01024L910.215997 0.01024zM910.215997 0.01024',
      //       params: boxParams,
      //       data: {
      //         type: 'live',
      //         maxLength: 10,
      //         list: []
      //       },
      //
      //       style: boxStyle
      //     },
      //     {
      //       code: 'tre-one',
      //       sort: 8,
      //       params: {},
      //       name: '单直播',
      //       icon: 'M165.789 99.167h783c22.5 0 40.5 18 40.5 40.5v319.5c-40.5-31.5-117-81-175.5-81-85.5 0-162 198-256.5 198-72-4.5-171-85.5-283.5-72-45 9-108 81-148.5 135v-499.5c0-22.5 18-40.5 40.5-40.5zM354.788 423.167c-36 0-67.5-13.5-90-36s-36-58.5-36-90c0-31.5 13.5-67.5 36-90 22.5-22.5 54-36 90-36 31.5 0 63 13.5 90 36 22.5 22.5 36 58.5 36 90 0 31.5-13.5 67.5-36 90-27 22.5-58.5 36-90 36zM971.288 40.667h-828c-45 0-81 36-81 81v738c0 45 36 81 81 81h828c45 0 81-36 81-81v-738c0-45-36-81-81-81z',
      //       data: {
      //         type: 'live',
      //         data: {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         }
      //       },
      //       style: treOneStyle
      //     },
      //     {
      //       code: 'tre-two',
      //       sort: 9,
      //       params: {},
      //       name: '双直播',
      //       icon: 'M888.884513 171.979487l1.024 6.406564 15.596308 108.806564 3.203282 0.183795a196.923077 196.923077 0 0 1 185.842871 199.916308l-0.210051 6.459077-15.937641 320.905846a196.923077 196.923077 0 0 1-206.454154 186.919385l-498.162872-32.295385a196.923077 196.923077 0 0 1-184.162461-193.929846 196.949333 196.949333 0 0 1-134.852923-151.788308l-1.155282-6.931692-47.156513-313.501539a196.923077 196.923077 0 0 1 159.166359-222.995692l6.301538-1.050256L668.278154 11.237744a196.923077 196.923077 0 0 1 220.553846 160.768zM511.684923 613.139692l-3.465846 2.940718-226.67159 210.996513a118.101333 118.101333 0 0 0 97.332513 63.645539l495.195897 32.111589 7.351795 0.262564a118.180103 118.180103 0 0 0 103.581539-60.757333l-162.264616-151.289436a42.089026 42.089026 0 0 0-51.331282-4.726154l-3.36082 2.363077-26.098872 20.48a52.512821 52.512821 0 0 1-69.526974-4.201025l-2.993231-3.255795-85.333333-101.060923-1.654154-1.890462a52.512821 52.512821 0 0 0-70.761026-5.618872z m-106.574769-275.114666a118.153846 118.153846 0 0 0-123.090051 112.981333l-13.548308 316.468513 203.986051-189.833846a105.025641 105.025641 0 0 1 148.427487 5.330051l3.360821 3.807179 85.333333 101.034667 26.072616-20.453744a94.601846 94.601846 0 0 1 118.731487 1.601642l4.174769 3.675897 141.495795 131.938461 15.596308-314.683076a118.153846 118.153846 0 0 0-105.83959-123.405129l-5.513846-0.420102z m279.368205-249.357129l-5.513846 0.630154L183.611077 157.013333a118.153846 118.153846 0 0 0-99.958154 128.866462l0.708923 5.513846L131.492103 604.947692a117.996308 117.996308 0 0 0 61.387487 86.75118l10.450051-244.053334a196.923077 196.923077 0 0 1 205.141333-188.33723l416.794257 23.420718-13.338257-93.131488a118.153846 118.153846 0 0 0-127.448615-100.929641z m168.854974 310.875898a91.897436 91.897436 0 1 1 0 183.794872 91.897436 91.897436 0 0 1 0-183.794872z m0 52.51282a39.384615 39.384615 0 1 0 0 78.769231 39.384615 39.384615 0 0 0 0-78.769231z',
      //       data: {
      //         type: 'live',
      //         maxLength: 2,
      //         list: [{
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源2',
      //           subName: '资源2',
      //           price: 0,
      //           scanNum: 0
      //         }
      //         ]
      //       },
      //       style: treTwoStyle
      //     },
      //     {
      //       code: 'tre-more',
      //       sort: 10,
      //       params: {},
      //       name: '多个直播',
      //       icon: 'M888.884513 171.979487l1.024 6.406564 15.596308 108.806564 3.203282 0.183795a196.923077 196.923077 0 0 1 185.842871 199.916308l-0.210051 6.459077-15.937641 320.905846a196.923077 196.923077 0 0 1-206.454154 186.919385l-498.162872-32.295385a196.923077 196.923077 0 0 1-184.162461-193.929846 196.949333 196.949333 0 0 1-134.852923-151.788308l-1.155282-6.931692-47.156513-313.501539a196.923077 196.923077 0 0 1 159.166359-222.995692l6.301538-1.050256L668.278154 11.237744a196.923077 196.923077 0 0 1 220.553846 160.768zM511.684923 613.139692l-3.465846 2.940718-226.67159 210.996513a118.101333 118.101333 0 0 0 97.332513 63.645539l495.195897 32.111589 7.351795 0.262564a118.180103 118.180103 0 0 0 103.581539-60.757333l-162.264616-151.289436a42.089026 42.089026 0 0 0-51.331282-4.726154l-3.36082 2.363077-26.098872 20.48a52.512821 52.512821 0 0 1-69.526974-4.201025l-2.993231-3.255795-85.333333-101.060923-1.654154-1.890462a52.512821 52.512821 0 0 0-70.761026-5.618872z m-106.574769-275.114666a118.153846 118.153846 0 0 0-123.090051 112.981333l-13.548308 316.468513 203.986051-189.833846a105.025641 105.025641 0 0 1 148.427487 5.330051l3.360821 3.807179 85.333333 101.034667 26.072616-20.453744a94.601846 94.601846 0 0 1 118.731487 1.601642l4.174769 3.675897 141.495795 131.938461 15.596308-314.683076a118.153846 118.153846 0 0 0-105.83959-123.405129l-5.513846-0.420102z m279.368205-249.357129l-5.513846 0.630154L183.611077 157.013333a118.153846 118.153846 0 0 0-99.958154 128.866462l0.708923 5.513846L131.492103 604.947692a117.996308 117.996308 0 0 0 61.387487 86.75118l10.450051-244.053334a196.923077 196.923077 0 0 1 205.141333-188.33723l416.794257 23.420718-13.338257-93.131488a118.153846 118.153846 0 0 0-127.448615-100.929641z m168.854974 310.875898a91.897436 91.897436 0 1 1 0 183.794872 91.897436 91.897436 0 0 1 0-183.794872z m0 52.51282a39.384615 39.384615 0 1 0 0 78.769231 39.384615 39.384615 0 0 0 0-78.769231z',
      //       data: {
      //         type: 'live',
      //         maxLength: 10,
      //         list: [{
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源1',
      //           subName: '资源1',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源2',
      //           subName: '资源2',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源3',
      //           subName: '资源3',
      //           price: 0,
      //           scanNum: 0
      //         },
      //         {
      //           id: undefined,
      //           picture: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
      //           name: '资源3',
      //           subName: '资源4',
      //           price: 0,
      //           scanNum: 0
      //         }
      //         ]
      //       },
      //       style: treMoreStyle
      //     },
      //   ]
      // }
    ]
  }
]
